import { useWallet } from '@aptos-labs/wallet-adapter-react'
import { formatPublicKeyDisplay } from 'toolbox/format'
import copy from 'assets/icons/copy.svg'
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

export interface WalletDisconnectProps {
  disconnect: () => void
  closeModal: () => void
}

function WalletDisconnect({ disconnect, closeModal }: WalletDisconnectProps) {
  const { account } = useWallet()
  const modalRef = useRef(null)
  const query = new URLSearchParams(useLocation().search)
  const viewportfolio = query.get('viewportfolio')
  const address = viewportfolio || account?.address

  const handleButtonClick = (e) => {
    e.stopPropagation()
    navigator.clipboard.writeText(address as string)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [closeModal])

  if (viewportfolio) {
    return null
  }

  return (
    <>
      <div className="disconnect-modal" ref={modalRef} onClick={(e) => e.stopPropagation()}>
        <div className="inner" onClick={(e) => e.stopPropagation()}>
          <div className="add-bar">
            <p>{formatPublicKeyDisplay(address)}</p>
            <button onClick={handleButtonClick} className="tp">
              <img src={copy} alt="copy" />
            </button>
          </div>
          <hr className="hr" />
          <div className="disconnect">
            <button className="sp-btn full-w tertiary" onClick={disconnect}>
              <p className="pri">Disconnect</p>
            </button>
          </div>
          <div className="links">
            <a
              href="https://www.concordia.systems/"
              className="a-link grey"
              rel="noopener noreferrer"
              target="_blank">
              Concordia
            </a>
          </div>
        </div>
      </div>
      <div className="close-helper" onClick={closeModal} />
    </>
  )
}

export default WalletDisconnect
